module.exports = {"data":{"site":{"siteMetadata":{"title":"Czech Milk","languages":{"defaultLangKey":"en","langs":["cs","en","fr"]}}}},"pathContext":{"slug":"/","langKey":"en"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 1418
// module chunks = 142629428675168